import React from 'react'
import { LnsCadastroRapidoContextProvider } from '../../../contexts/LnsCadastroRapido';
import QuickRegisterContent from './QuickRegisterContent';


export default function LnsQuickRegister() {
    return (
        <LnsCadastroRapidoContextProvider>
            <QuickRegisterContent />
        </LnsCadastroRapidoContextProvider>

    )
}
